// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import { descriptionStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsDescription";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

descriptionStyles.wrapper = {
    css: css`
        font-size: 16px;
        line-height: 24px;
        &:before {
            content: '${translate("Description")}';
            display: block;
            font-size: 18px;
            line-height: 22px;
            font-weight: ${fontConfig.weight.bold};
            margin-bottom: 8px;
        }
        ${xScreen("lt","sm")} {
            margin-bottom: 25px;
        }
    `,
}